import tlds from './tlds';

// Локальная часть: буквы, цифры и разрешённые спецсимволы, разделённые точками.
const LOCAL_PART_REGEXP = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
// Домен: метки длиной до 63 символов, без дефиса в начале и конце.
const DOMAIN_LABEL_REGEXP = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
// TLD: только буквы или punycode (для кириллических зон вроде .рф).
const TLD_REGEXP = /^(?:[a-z]{2,63}|xn--[a-z0-9-]{2,59})$/;
// В исходном домене допускаем только буквы, цифры, точки и дефисы (включая Unicode).
const DOMAIN_SOURCE_REGEXP = /^[A-Za-z0-9.\-\u00A1-\uFFFF]+$/;

const toAsciiDomain = (domain) => {
    if (!DOMAIN_SOURCE_REGEXP.test(domain)) {
        return '';
    }

    try {
        // URL приводит домен к нижнему регистру и конвертирует IDN в punycode.
        return new URL(`http://${domain}`).hostname;
    } catch (e) {
        return '';
    }
};

const isEmail = (value) => {
    if (typeof value !== 'string') {
        return false;
    }

    const email = value.trim();

    if (!email || email.length > 254) {
        return false;
    }

    const separatorIndex = email.lastIndexOf('@');

    if (separatorIndex <= 0 || separatorIndex === email.length - 1) {
        return false;
    }

    const localPart = email.slice(0, separatorIndex);
    const domain = email.slice(separatorIndex + 1);

    if (localPart.length > 64 || !LOCAL_PART_REGEXP.test(localPart)) {
        return false;
    }

    const asciiDomain = toAsciiDomain(domain);
    const labels = asciiDomain.split('.');
    const tld = labels[labels.length - 1];

    if (labels.length < 2 || !labels.every((label) => DOMAIN_LABEL_REGEXP.test(label))) {
        return false;
    }

    return TLD_REGEXP.test(tld) && tlds.has(tld);
};

export default isEmail;
